import { GzRmSeverity } from './component/GzRmSeverity';

export { GzRmSeverity };
